
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.7 78.7S64 61 128 83.2c0 0-51.8-10.7-118.3-4.5zM0 66.8h2.9l1.6-16.6L11.9 67h.6L20 49.9l1.5 17h6.6l-2.3-22h-6.7l-4.8 11.7-5.2-11.8H.3v.8s2.1-.3 1.8 2.5L0 66.8zM30 46.9v.7s1.9-.2 1.9 2.5v17h5.8V46.9H30zM40.9 46.8V51h.6s-.2-1.7 2.1-1.7h6.7l-10 17v.7H59v-2.6H48.2l10.2-16.9v-.7H40.9zM59.3 46.8H67v14.4s-.5 3.9 3.9 3.9h3.5V50s.4-2.2-1.8-2.2v-.9h7.8v8.6h7.4v-6.1s.3-1.9-1.9-1.9v-.7h7.7v20h-6s.3-1.9.3-3.1v-5.9H80v6.4s-.1 1.3.2 2.6c0 0-5.7.5-9.3.5-3.6 0-10 .1-10-7.7v-9.1s.2-2.9-1.7-2.9v-.8zM107.4 46.4c-6.5 0-11.8 4.6-11.8 10.3 0 5.7 5.3 10.3 11.8 10.3 6.5 0 11.8-4.6 11.8-10.3 0-5.7-5.3-10.3-11.8-10.3zm0 18.6c-3.3 0-6-3.6-6-8s2.7-8 6-8 5.9 3.6 5.9 8-2.6 8-5.9 8z"}})])
          )
        }
      }
    